import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { isNull } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ExcelCaaListsService {

  private numberFormat = "#,##0.00";
  private fontStyle = {
    header: { name: 'Times New Roman', size: 10, bold: true },
    content: { name: 'Times New Roman', size: 10 }
  };
  private borderStyle: any = {
    thin: { style: 'thin' },
    full: {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    },
    topBottom: {
      top: { style: 'thin' },
      bottom: { style: 'thin' }
    },
    leftRight: {
      left: { style: 'thin' },
      right: { style: 'thin' }
    },
    topLeft: {
      top: { style: 'thin' },
      left: { style: 'thin' }
    },
    topRight: {
      top: { style: 'thin' },
      left: { style: 'thin' }
    },
    bottomLeft: {
      bottom: { style: 'thin' },
      left: { style: 'thin' }
    },
    bottomRight: {
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  };

  async generateORSListSummaryExcel(data: Array<any>, options: any = { fileName: "CAA_Lists", sheetName: "CAA" }) {
    const wb = new ExcelJS.Workbook();
    wb.addWorksheet(options.sheetName);

    const ws = wb.getWorksheet(options.sheetName);

    ws.columns = [
      { header: "Date", key: "caa_date", width: 12 },
      { header: "No.", key: "caa_no", width: 12 },
      { header: "Fund Source", key: "fund_source", width: 12 },
      { header: "Function", key: "fund_function", width: 12 },
      { header: "Reguarl Budget / Project/ PAPs", key: "bgt_type", width: 12 },
      { header: "DEPARTMENT", key: "department", width: 12 },
      { header: "EBOE", key: "eboe", width: 12 },
      { header: "UACS", key: "acct_uacs_code", width: 12 },
      { header: "Object of Expenditures", key: "acct_name", width: 12 },
      { header: "Amount", key: "amount", width: 12, style: { numFmt: this.numberFormat } },
      { header: "Total Amount", key: "expended_amount", width: 12, style: { numFmt: this.numberFormat } },
      { header: "PR No.", key: "pr_no", width: 12 },
      { header: "PR Amount", key: "pr_amount", width: 12, style: { numFmt: this.numberFormat } },
      { header: "PR Date", key: "pr_date", width: 12 },
      { header: "Supplier", key: "supplier", width: 12 },
      { header: "Date", key: "or_date", width: 12 },
      { header: "No.", key: "or_number", width: 12 },
      { header: "Amount", key: "os_amount", width: 12, style: { numFmt: this.numberFormat } },
      { header: "Balance", key: "os_balance", width: 12, style: { numFmt: this.numberFormat } },
      { header: "Savings", key: "os_savings", width: 12, style: { numFmt: this.numberFormat } },
      { header: "Item", key: "os_item", width: 12 },
      { header: "Qty", key: "os_qty", width: 12 },
      { header: "Total Cost", key: "os_total_cost", width: 12, style: { numFmt: this.numberFormat } },
      { header: "Cancellation Date", key: "os_cancellation_date", width: 12 },
      { header: "Cancelled Amount", key: "os_cancelled_amount", width: 12, style: { numFmt: this.numberFormat } },
    ];

    let cols = [
      "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
    ];

    ws.getRow(1).height = 60;

    cols.forEach((col: string) => {
      let cell = ws.getCell(`${col}1`);
      cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
      cell.border = this.borderStyle.full;
      cell.font = this.fontStyle.header;
    });

    // parse int
    let numberValues = [
      "amount", "expended_amount", "pr_amount", "os_amount", "os_balance", "os_savings", "os_total_cost", "os_cancelled_amount"
    ];

    data.forEach((dt: any, dtIndex: number) => {
      numberValues.forEach((nv: string) => dt[nv] = ((parseInt(dt[nv]) != 0 && (dt[nv] != null || dt[nv] != undefined)) ? parseFloat(dt[nv]) : ''));
      ws.addRow(dt);
      cols.forEach((col: string, colIndex: number) => {
        let cell = ws.getCell(`${col}${dtIndex + 2}`);

        // Check if this column contains numeric data
        const columnKey = ws.columns[colIndex]?.key;
        if (columnKey && numberValues.includes(columnKey)) {
          cell.style = { numFmt: this.numberFormat };
          cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'right' };
        } else {
          cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        }

        cell.border = this.borderStyle.full;
        cell.font = this.fontStyle.content;
      });
    });

    const arrayData = await wb.xlsx.writeBuffer();
    const blob = new Blob([arrayData], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${options.fileName}.xlsx`;
    a.click();
    a.remove();
  }

}
